.container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.6rem;
}
